<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form class="form" :model="self_form" :rules="rules" ref="form" label-width="12%">
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>基础信息</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类：" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :platform="platform" />
            </div>
          </el-form-item>
          <el-form-item label="品牌：" prop="brandId">
            <BrandIdBlock
              ref="brandIdBlockRef"
              v-model="self_form.xhsShopBrandList"
              :shopList="shopList"
              :categoryIds="self_form.categoryIds"
              />
              <div class="tips ft-12">
                <span>如未找到需要的品牌，可提供品牌商标申请品牌</span>
                <a target="_blank" href="https://ark.xiaohongshu.com/ark/brand?tab=2">点击申请</a>
              </div>
          </el-form-item>
          
          <el-form-item label="商品标题：" prop="name">
            <el-input type="text" placeholder="请输入" 
              v-model="self_form.name" show-word-limit> 
               <span slot="suffix" style="margin-right: 6px;">{{ getBytesCount(self_form.name) }}/60</span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <span>商品标题必须包含产品名称，不得包含品牌名、诱导词、营销词、极限词及与商品无关的信息等，查看</span>
              <a target="_blank" href="https://school.xiaohongshu.com/rule/detail/61cb74a60000000000000000/61e8db7316a4f800166cbe34?jumpFrom=ark">商品标题完整规则</a>
            </div>
          </el-form-item>
          <el-form-item label="商品英文名：" prop="ename">
            <el-input type="text" placeholder="请输入" v-model="self_form.ename" maxlength="60" show-word-limit> </el-input>
          </el-form-item>
          <el-form-item label="货号：" prop="articleNo">
            <el-input type="text" placeholder="请输入" v-model="self_form.articleNo" maxlength="60" show-word-limit> </el-input>
          </el-form-item>
          <el-form-item label="商品属性：">
            <UseCategoryTemplate :categoryIds="self_form.categoryIds" :platform="platform" :baseItemId="baseItemId" :propValues="self_form.attributeList" @clickFill="clickTemPlateFill">
              <CategoryProps
                ref="cateprops"
                v-model="self_form.attributeList"
                :categoryIds="self_form.categoryIds"
                @refundRuleChange="updateRefundRule"/>
            </UseCategoryTemplate>
            <div class="tips ft-12">
              <span>错误填写类目、属性，可能会引起商品下架，影响您的正常销售，请认真填写</span>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>价格库存</span>
        </div>
        <div class="conf" v-if="self_form.categoryIds && self_form.categoryIds.length" props="categoryIds">
          <el-form-item label="发货模式：" prop="deliveryTimeObject.option">
            <span slot="label">
              <el-popover effect="dark" placement="top" trigger="hover">
                <i class="el-icon-Group-14" slot="reference" style="font-size: 14px;"></i>
                <div>
                  <p>时段预售：选择后即为预售商品，可设置在支付成功后的X天内完成发货</p>
                  <p>定时预售：最大可设置X天预售时间，需要在预售时间当天的23:59:59前完成发货</p>
                  <p>按规格设置发货时间：规格(sku)维度预售，可设置规格指定时间发货</p>
                  <p>现货非预售获得流量扶持，详情了解 <a href="https://ark.xiaohongshu.com/app-order/shipping/rights" target="_blank">小红书商家管理后台</a></p>
                </div>
              </el-popover>
              发货模式：
            </span>
            <el-radio-group v-model="self_form.deliveryTimeObject.option" @change="deliveryTimeObjectChange">
              <el-radio :label="0">现货模式</el-radio>
              <el-radio :label="optionEnum.presale">全款预售模式</el-radio>
              <el-radio :label="4">现货+预售模式</el-radio>
              <el-radio :label="3">按规格设置发货时间</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label='全款预售发货时间' v-if="self_form.deliveryTimeObject.option === optionEnum.presale">
            <el-radio-group v-model="self_form.deliveryTimeObject.optionEnum" @change="deliveryTimeObjectChangeEnum">
              <el-radio :label="1">时段预售</el-radio>
              <el-radio :label="2">定时预售</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="self_form.deliveryTimeObject.option !== optionEnum.presale ? '现货发货时间' : '预售发货时间'" prop="deliveryTimeObject.time" v-if="self_form.deliveryTimeObject.option != 3">
            <template v-if="[0,4].includes(self_form.deliveryTimeObject.option)">
              <el-radio-group v-model="self_form.deliveryTimeObject.time" @change="v => deliveryTimeChange(v)">
                <span v-for="item in existingList"  :key="item.value + '_' + item.type ">
                  <el-radio :label="item.time" style="margin-right: 20px;"> {{ item.label }}
                  <el-tooltip v-if="item.desc" :content="item.desc" effect="dark" placement="bottom">
                    <i class="el-icon-Group-14" style="font-size: 14px;"></i>
                  </el-tooltip>
                </el-radio>
                </span>
              </el-radio-group>
            </template>
            <template v-else-if="self_form.deliveryTimeObject.optionEnum == 1">
              付款后   
              <el-input-number 
                v-model="self_form.deliveryTimeObject.time"
                style="width: 150px" 
                controls-position="right"
                :min="relativePre.min"
                :max="relativePre.max"
                @change="deliveryTimeChange"
              ></el-input-number>
               天发货
            </template>
            <template v-else-if="self_form.deliveryTimeObject.optionEnum == 2 && isParseTrue(self_form.deliveryTimeObject.time)" >
              <el-date-picker width="200px" v-model="self_form.deliveryTimeObject.time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" @change="v => deliveryTimeChange(v)">
              </el-date-picker>
            </template>
            <div class="tips ft-12">
              <span>请在承诺发货时间内完成发货，否则会引起赔付与退款。</span>
              <a target="_blank" href="https://school.xiaohongshu.com/rule/detail/5d6935880000000000000000/6444d96c55d430001a453941?entry=00020002&jumpFrom=ark">详情</a>
            </div>
          </el-form-item>
          <el-form-item v-if="self_form.deliveryTimeObject.option == 4" label="预售发货时间" prop="deliveryTimeObject.preSaleTime">
            <el-checkbox-group v-model="self_form.deliveryTimeObject.preSaleTime" :max="3">
              <el-checkbox v-for="(item, index) in stepDeliveryTime" :key="index" :label="item">
                {{item}}天
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="!self_form.pureType" label="商品规格：" :rules="[{required: true, message:'请填写商品规格'}]">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification ref="specificationRef" v-model="specifications" :variations="variations" :changeToBase="changeToBase" :isPlatform="true" :platform="platform" :autoCropImageConfigList="autoCropImageConfigList" @fieldChanged="specificationsFieldChanged"/>
          </el-form-item>
          <!-- <pre>{{skuList}}</pre> -->
          <el-form-item v-if="!self_form.pureType" label="规格明细：">
            <FormItemSkuList
              :isXhs="true"
              :specifications="specifications"
              :baseItemId="baseItemId"
              skuSpecificationsKey="skuSpecifications"
              :tableCols="skuTableCols"
              v-model="skuList"
              @fieldChanged="specificationsFieldChanged"
            >
            <template slot="deliveryTimeSlot" slot-scope="{ row }">
              <el-cascader
                style="width: 136px; margin-right: 10px;"

                v-model="row.deliveryTimeObject.selectValue"
                :options="skuDeliveryOptions"
                :props="{ expandTrigger: 'hover' }"
                @change="value => skuDeliveryTimeChange(value, row.deliveryTimeObject)">
              </el-cascader>
              <template v-if="row.deliveryTimeObject.selectValue && row.deliveryTimeObject.selectValue.join(',') === '1,1'">
                <el-input-number
                  v-model="row.deliveryTimeObject.time"
                  style="width: 80px" 
                  controls-position="right"
                  :min="relativePre.min"
                  :max="relativePre.max"
                ></el-input-number>
                天
              </template>
              <template v-else-if="row.deliveryTimeObject.selectValue && row.deliveryTimeObject.selectValue.join(',') === '1,2' && isParseTrue(row.deliveryTimeObject.time)">
                <el-date-picker width="110px" v-model="row.deliveryTimeObject.time" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
              </template>
            </template>
          </FormItemSkuList>
          <template v-if="specificationsValidResult !== true">
              <div class="el-form-item__error">{{ specificationsValidResult }}</div>
            </template>
          </el-form-item>
        </div>
        <div class="no-specifications" v-else>
          请选择商品分类
        </div>
      </section>
      <section>
        <div class="title">
          <span>图文信息</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
            <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
            <GroupImagesList :baseItemId="baseItemId" :specifications="specifications" :hideImgs="['mainImages34']" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <el-form-item label="主图：" prop="imageList">
            <div class="imgs-wrp">
              <div class="ft-12">展示时只取主图，拖动可调整顺序<BatchEditImages v-model="self_form.imageList" refName="imageList" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
              <MutiImgUpload
                ref="imageList"
                v-model="self_form.imageList"
                :limitSize="autoCropImageConfigList.includes('mainImg') ? 0 : 3 * 1024 * 1024"
                :aspectRatio="autoCropImageConfigList.includes('mainImg') ? 0 : [1,0.75]"
                aspectRatioText="1:1或3:4"
                :aspectRatioLimitWidth="[[800, 0], [750, 0]]"
                :limitNums="10"
                :mainImgNums="0"
                limitSuffix=".jpg,.png,.jpeg"
                :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                :supportAiRetry="true"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div>商品主图：图片宽高比1:1或3:4，格式JPG/JPEG/PNG，大小3M以内，拖拽可排序；1:1比例图片像素不低于800*800px，3:4比例图片像素不低于750*1000px</div>
              <div>商品首图：商品主图的第一张为商品首图（商品首图会展示在店铺页/商品笔记/搜索结果等商品入口）商品首图必须满足：无任何文字信息（除品牌logo外），否则将无法正常售卖。
                  <a
                    href="https://school.xiaohongshu.com/rule/detail/61cb74a60000000000000000/61e8dbe90641540017d1f0a9?jumpFrom=ark"
                    target="_blank"
                  >
                    查看首图完整规范-2.1基础规则
                  </a>
              </div>
              <div>
                首图若满足：①宽高比为1:1 ②背景简洁、产品完整 ③主体居中
                  ④非拼图/合成图等，商品将可出现在商城首页，获得更多的曝光机会（若不满足不可出现在商城首页，但不影响在店铺页/商品笔记中正常售卖）
                  <a href="https://school.xiaohongshu.com/rule/detail/61cb74a60000000000000000/61e8dbe90641540017d1f0a9?jumpFrom=ark" target="_blank">
                    查看首图完整规范-2.2商城首页主图规则
                  </a>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="透明素材图：" prop="transparentImage">
            <ImgUpload
              ref="transparentImage"
              :file="self_form.transparentImage"
              :limitSize="autoCropImageConfigList.includes('whiteImg') ? 0 : 3 * 1024 * 1024"
              :limitWidth="autoCropImageConfigList.includes('whiteImg') ? [0, 0] :[800, 0]"
              :limitHeight="autoCropImageConfigList.includes('whiteImg') ? [0, 0] :[800, 0]"
              :aspectRatio="autoCropImageConfigList.includes('whiteImg') ? 0 : 1"
              :aspectRatioText="autoCropImageConfigList.includes('whiteImg') ? '' : '1:1'"
              limitSuffix=".png"
              :strictSuffix="true"
              :isSingle="true"
              :autoCropImageParams="{targetWidth:800,targetHeight:800,targetFormat:'png'}"
              @upload-success="(url) => (self_form.transparentImage=url)"
              @del="() => (self_form.transparentImage = '')"
            />
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div>
                透明素材图：PNG格式的透明底图片，图片像素不低于800*800px（1:1比例），大小3M以内，
                <a href="https://school.xiaohongshu.com/lesson/normal/fff8f14862914eb6a5617e1e0d9a80de?jumpFrom=ark" target="_blank">
                  查看完整规范
                </a >
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品描述：" prop="description">
            <el-input type="text" :rows="3" placeholder="请输入商品描述" v-model="self_form.description" maxlength="500" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="图文描述：" prop="imageDescriptionsList">
            <div><BatchEditImages v-model="self_form.imageDescriptionsList" refName="imageDescriptionsList" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <MutiImgUpload ref="imageDescriptionsList" 
            v-model="self_form.imageDescriptionsList" 
            limitSuffix=".jpg,.png,.jpeg"
            :supportAiRetry="true"
            :mainImgNums="0" />
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div>1、文描所有图片高度总和不得超过 50000px，图片格式支持JPG/JPEG/PNG；可拖拽排序</div>
              <div>2、服饰鞋包/运动户外等类目上传商品尺码信息，有助于商品流量获取、促进交易转化。</div>
            </div>
          </el-form-item>
          <el-form-item label="商品视频:">
            <el-row style="display: flex; align-items: center;">
              <VideoUpload :video="self_form.videoVo" aspectRatio="1:1,3:4,16:9" :limitDuration="60" :limitTitle="64" @upload-success="v => handleVideo(v, 1)" @del="v => handleVideo(v, 0)"/>
            </el-row>
          </el-form-item>
          <el-form-item>
            <div class="tips ft-12">
              <div>视频尺寸比1:1或3:4或16:9，时长15s - 60s，分辨率不低于720p；</div>
              <div>视频比例优先以商品首图为准，系统会自动帮您按照首图比例压缩视频，可能影响展示，建议视频和商品首图尺寸比相同。</div>
            </div>
          </el-form-item>
          <div style="position:relative">
            <el-button type="link" @click="addQuestion" style="position:absolute; right:10px; bottom:10px">添加问题</el-button> 
          </div>
          <div style="background:#F5F5F5;padding:30px 10px 10px 0px;position:relative" v-for="(item,index) in faqList" :key="index">
            <el-button type="link" @click="deleteQuestion(index)" style="position:absolute; right:10px; top:5px">删除</el-button> 
            <el-form-item label="常见问题：" prop="question">
              <el-input type="text" placeholder="请输入" v-model="item.question"> </el-input>
            </el-form-item>
            <el-form-item label="常见问题答案：" prop="answer">
              <el-input type="text" :rows="4" placeholder="请输入" v-model="item.answer"> </el-input>
            </el-form-item>
          </div>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item label="上架设置:" prop="shelfState" :rules="[{ required: true, message: '请选择上架设置' }]">
            <el-radio-group v-model="self_form.shelfState">
              <el-radio :label="1">立即上架</el-radio>
              <el-radio :label="2">放入仓库中</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>服务信息</span>
        </div>
        <div class="conf">
          <el-form-item label="物流模版：" prop="xhsShopLogisticsPlanList">
            <LogisticsBlock v-if="shopList.length" :shopList="shopList" v-model="self_form.xhsShopLogisticsPlanList"></LogisticsBlock>
          </el-form-item>
          <el-form-item label="运费模版：" prop="xhsShopShippingTemplateList">
            <TemplateBlock v-if="shopList.length" :shopList="shopList" v-model="self_form.xhsShopShippingTemplateList"></TemplateBlock>
          </el-form-item>
        </div>
     
      </section>
    </el-form>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import ImgUpload from "@/components/Uploads/ImgUpload";
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import VideoUpload from '@/components/Uploads/videoUpload'
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryInput from '../PlatformCategoryInput/index.vue';
import ReuseLastCategory from '../PlatformCategoryInput/ReuseLastCategory.vue';
import CategoryProps from './CategoryProps.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import BrandIdBlock from './BrandIdBlock.vue';
import LogisticsBlock from './LogisticsBlock.vue';
import TemplateBlock from './TemplateBlock.vue';
import FormItemSpecification from './FormItemSpecification';
import { mapGetters } from "vuex"

import { last, get, cloneDeep } from 'lodash';
import { getBytesCount } from "@utils/data"
import RULES from './rules.js';

import { specification_mixin } from '../FormItemSpecification';
import { logisticsList, getXhsDeliveryRule, getMappingVariations, variations, specAutoMerge, editCarouselVideo } from '@/servers/prod/center/xhs.js';
import { getDistributionConfig } from "@servers/prod/conf/index.js";
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import dayjs from 'dayjs';

export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  provide(){
    return {
      platform: 'xhs',
      openSource:this.openSource
    }
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  components: {
    ImgUpload,
    MutiImgUpload,
    VideoUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    ReuseLastCategory,
    CategoryProps,
    UseCategoryTemplate,
    BrandIdBlock,
    LogisticsBlock,
    TemplateBlock,
    FormItemSpecification
  },
  props: {
    form: {
      type: Object,
      default() {
        return {};
      },
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      platform: 'xhs',
      getBytesCount,
      self_form: {},
      showGroupImages: true,
      rules: RULES(this),
      skuTableCols:[
        {prop: 'spotPresaleName', attrs: {label: '发货时效'}, unvisible: true },
        { 
          prop: 'price', attrs: { label: '售价' }, 
          input: { 
            type: 'number',
            validator(value, prop, sku) {
              if (!value) {
                return `规格明细中 售价 必须大于0`
              } else if(sku.originalPrice && value > sku.originalPrice) {
                return `规格明细中 售价 不能大于市场价`
              }
              return false
            } 
          } ,
          disabledFn: row => {
            return (row.isPresale && this.self_form.deliveryTimeObject.option == 4);
          },
        },
        { 
          prop: 'originalPrice', attrs: { label: '市场价', noRequired: true }, input: { type: 'number' },
          disabledFn: row => {
            return (row.isPresale && this.self_form.deliveryTimeObject.option == 4);
          },
        },
        { prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true },unvisible:JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0? true : false  },
        { prop: 'deliveryTime', attrs: { label: '发货时间', width: 280 }, slot: true, unvisible: false },
        {
          prop: 'stock',
          attrs: { label: '库存' },
          input: { 
            type: 'number',
            validator(value, prop) {
              if (value === "" || value === undefined || value === null) {
                  return `规格明细中 库存 请勿输入空值`
              } else if(value > 100000) {
                  return `规格明细中 库存 不能超过100000`
              }
              return false
            } 
          },
          disabledFn: row => {
            return this.form?.pureType || row.stockType === 1;
          },
        },
        { prop: 'erpCode', attrs: { label: '商品编码', width: 200, noRequired: this.isGroupPuhuo },unvisible: this.openSource === 'shopGoods' },
      ],
      orginSpecifications: [],
      skuSpecificationsKey: 'skuSpecifications',
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: false, // 规格需要校验图片是否补充
      shipsTemplate: null, // 运费模板列表
      shipsValue: null, // 运费模板值
      templateConfigMap: null, // 初始值
      originalTemplateConfig: null,
      originalXhsShopLogisticsPlanList: null, // 原始物流方案配置（用于保存时恢复未显示店铺的数据）
      originalXhsShopShippingTemplateList: null, // 原始运费模版配置（用于保存时恢复未显示店铺的数据）
      originalXhsShopBrandList: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
      faqList:[{
        question:'',
        answer:''
      }],
      logisticsPlanId: '',
      variations:[], // 规格列表
      xhsSpecMaxNum: 2, // 允许规格的最大数量
      existingList: [],
      relativePre: {},
      absolutePre: {},
      skuDeliveryOptions: [],
      optionEnum : {
        existing: 0, 
        presale:'1,2',
        stepPresale:4,
        byVariant:3,
      },
      isXhs: true,
      stepDeliveryTime: [],
      hasSizeError:false,
      autoCropImageConfigList: [],
      detailCategoryId: '',
      detailCategoryIdChange: false,
    };
  },
  watch: {
    form: {
      async handler(v) {
        await this.getConf();
        this.handleSkuList(v.skuList)
        this.faqList = v.faqList || [{question:'',answer:''}];

        this.orginSpecifications = v.specifications?.length ? JSON.parse(JSON.stringify(v.specifications)) : []
        if (v.templateConfig && v.templateConfig.length) {
            this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        if (v.xhsShopLogisticsPlanList && v.xhsShopLogisticsPlanList.length) {
            this.originalXhsShopLogisticsPlanList = cloneDeep(v.xhsShopLogisticsPlanList);
        }
        if (v.xhsShopShippingTemplateList && v.xhsShopShippingTemplateList.length) {
            this.originalXhsShopShippingTemplateList = cloneDeep(v.xhsShopShippingTemplateList);
        }
        if (v.xhsShopBrandList && v.xhsShopBrandList.length) {
            this.originalXhsShopBrandList = cloneDeep(v.xhsShopBrandList);
        }
        // let deliveryTimeObject = { option : 0, time: '2', type: 'RELATIVE_TIME_NEW', ...v.deliveryTimeObject }
        // 处理 deliveryTimeObject
        let deliveryTimeObject = { 
          option: 0, 
          time: '2', 
          type: 'RELATIVE_TIME_NEW', 
          preSaleTime: [],
          ...v.deliveryTimeObject 
        };
        
        if(deliveryTimeObject.option === 4){
          deliveryTimeObject.preSaleTime = Array.isArray(deliveryTimeObject.preSaleTime) ? 
            deliveryTimeObject.preSaleTime : 
            (deliveryTimeObject.preSaleTime || '').split(',');
        }
        if (deliveryTimeObject.option === 1) {
          deliveryTimeObject = {
            ...deliveryTimeObject,
            option: '1,2',
            optionEnum: 1
          }
        } else if (deliveryTimeObject.option === 2) {
          deliveryTimeObject = {
            ...deliveryTimeObject,
            option: '1,2',
            optionEnum: 2
          }
        }
        
        if(deliveryTimeObject.option === 2 && deliveryTimeObject.time) {
          deliveryTimeObject.time = deliveryTimeObject.time.replaceAll('/', '-')
        }
        if(!deliveryTimeObject.preSaleTime){ // preSaleTime初始化保证是一个数组
          deliveryTimeObject.preSaleTime = []
        }
        this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
        this.$set(this, 'self_form', {
          ...v,
          deliveryTimeObject
        });
        this.isShowSkuDeliveryTime()
        this.$nextTick(() => {
          this.validPage();
        });
      },
      immediate: true,
    },
    categoryId:{
      async handler(v) {
        if(v) {
          this.getMapSku()
          // 获取物流方案
          await this.getLogisticsList();
          await this.getDeliveryRules();
           // 检查是否需要初始化现货+预售模式
           const needInit = this.self_form.skuList?.some(item =>
            item.deliveryTimeObject?.deliveryFlag &&
            item.deliveryTimeObject?.option === 4
          );
          if (this.spotPresaleList.length && needInit) {
            this.initSelfFormSkuList()
          }
          if((this.detailCategoryId != this.categoryId) || this.detailCategoryIdChange){
            this.detailCategoryIdChange = true
            this.$nextTick(() => {
              this.$refs.brandIdBlockRef?.useBrandConfInit();
            });
          }
        }
      },
      immediate: true,
    },
  
    'self_form.deliveryTimeObject.preSaleTime': {
      handler(v) {
        if(this.self_form?.deliveryTimeObject?.time && this.self_form?.deliveryTimeObject?.option == 4 && v.length){
          this.skuTableCols.forEach(col => {
            if(col.prop === 'spotPresaleName') {
              col.unvisible = false
              return
            }
          })
        }
       
        // this.watchDeliveryTimeChange();
      },
      immediate: true
    },
    spotPresaleList: {
      handler(v) {
        this.createSkuListBySpecs()
        this.skuTableCols.forEach(col => {
          if(col.prop === 'spotPresaleName') {
            col.unvisible = !v.length
            return
          }
        })
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters([]),
    shopList() {
      let list = this.getShopList('xhs');
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list;
    },
    categoryId() {
      let categoryIds = this.self_form.categoryIds || [];
      return categoryIds.length ? categoryIds[categoryIds.length - 1] : '';
    },
    shopId() {
      return  this.$store.getters.shops_getCategoryPropShopId('xhs')
    },
    pickerOptions() {
      const self = this;
      return {
        disabledDate(time) {
          const curTime = dayjs(time).valueOf();
          const maxTime = Date.now() + (self.absolutePre?.max || 0) * 3600000
          const minTime = Date.now() + (self.absolutePre?.min - 24 || 0) * 3600000
          return curTime > maxTime || curTime < minTime;
        },
      };
    },
    spotPresaleList() {
      let list = []
      let { deliveryTimeObject = {} } = this.self_form;
      let { option, time = 2, preSaleTime } = deliveryTimeObject;
      if(option == 4 && time && preSaleTime) {
        const spotGoodsDay = this.getTimeLabel(time)
        list.push(spotGoodsDay)
        if(preSaleTime && preSaleTime.length){
          preSaleTime.map(item=>{
            list.push(item + '天内发货')
          })
        }
      }
      return list
    },

  },

  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },

    initSelfFormSkuList() {
      this.skuList = [];
      let skuList = [];
      const oriSkuList = cloneDeep(this.self_form.skuList)
      if (oriSkuList?.length) {
        skuList = oriSkuList.map(item => {
          const {option,time,preSaleTime } = item.deliveryTimeObject
          if(option == 4 && time && preSaleTime) {
            const spotGoodsDay = this.getTimeLabel(time)
            item.spotPresaleName = spotGoodsDay
            if(preSaleTime){
              item.spotPresaleName = preSaleTime + '天内发货'
            }
          }
          const _skuid = item.skuSpecifications.map(sp => sp.valueKey).join('-')
          return {
            ...item,
            _skuid,
            skuSpecifications: item.skuSpecifications
          }
        })
      }
      this.skuList = skuList;
      this.self_form.skuList = skuList;
      // console.log(this.self_form.skuList,563);
    },
   getTimeLabel(time) {
      const timeLabels = {
        '0': '当日发货',
        '1': '24小时内发货',
        '2': '48小时发货'
      };
      return timeLabels[time] || time;
    },
    getDeliveryTimeValue(text) {
      // 预定义的时间映射
      const timeMap = {
        '当日发货': '0',
        '24小时内发货': '1',
        '48小时发货': '2'
      };

      // 检查是否是预定义的时间
      if (timeMap[text]) {
        return timeMap[text];
      }

      // 提取"xx天内发货"中的数字
      const match = String(text).match(/(\d+)天内发货/);
      if (match) {
        return match[1];
      }

      return text;
    },
    // 处理详情数据不是现货+预售模式内容
    spotPresaleIntoSkuList(skuList) {
      if(!this.spotPresaleList.length) {
        return skuList
      }
      skuList = cloneDeep(skuList)
      let newSkuList = []
      skuList.forEach(skuListItem => {
        const { _skuid} = skuListItem;
        const skuIdList = this.self_form.skuList.filter(sku => sku._skuid === _skuid)
        this.spotPresaleList.forEach((spotPresale, spotPresaleIndex) => {
          let skuItem = {}
          // 查找已存在的SKU项
          const oldFindItem = this.skuList.find(sku => sku._skuid === _skuid && this.normalizeTime(sku.spotPresaleName) === this.normalizeTime(spotPresale))
          const findItem = this.self_form.skuList.find(sku => sku._skuid === _skuid && this.normalizeTime(sku.spotPresaleName) === this.normalizeTime(spotPresale)) 
          const oldSkus = this.skuList.filter(sku => sku._skuid === _skuid)
          // 基础SKU信息克隆
          skuItem = cloneDeep(oldFindItem || oldSkus[spotPresaleIndex] || findItem || skuListItem)
          
          skuItem.skuSpecifications = cloneDeep(skuListItem.skuSpecifications)
          skuItem.imageUrl = skuListItem.imageUrl
          skuItem.spotPresaleName = spotPresale
          if(!['48小时发货','24小时发货','当天发货','24小时内发货','当日发货'].includes(spotPresale)){
            skuItem.isPresale = true
          }

          // 找出预售时间相同的sku，把库存赋值过去
          let curSku = skuIdList.find(sku => spotPresale === sku.deliveryTimeObject.preSaleTime + '天内发货')
          if(curSku){
            skuItem.stock = curSku?.stock || 0
          }

          newSkuList.push(skuItem)
        })
      })
      return newSkuList
    },
    normalizeTime(timeStr) {
      if (!timeStr) return '';
      // 提取核心时间信息
      if (timeStr.includes('48小时')) return '48小时';
      if (timeStr.includes('24小时')) return '24小时';
      if (timeStr.includes('当日') || timeStr.includes('当天')) return '当日';
      // 提取"xx天内发货"中的数字
      const match = String(timeStr).match(/(\d+)天内发货/);
      if (match) return match[1] + '天内发货';
      return timeStr;
    },
    handleSkuList(skuList=[]) {
      skuList.map(item => {
        let { option, time, type,preSaleTime } = item.deliveryTimeObject || {}
        let newDeliveryTime = { selectValue: [],preSaleTime }
        // 当日发货: [0，0]     "TODAY"
        // 24小时： [0，1]      相对时间
        // 48小时： [0， 2]     相对时间
        // 时段预售：[ 1，1]     相对时间
        // 定时预售： [1，2]     绝对时间
        if(option === 0) {  // 非预售
          if(time !== undefined) {
            newDeliveryTime.selectValue = [0, time]
          }
        } else if(option === 1) {  // 时段预售
          newDeliveryTime.selectValue = [1, 1]
        } else if(option === 2) {  //  定时预售
          newDeliveryTime.selectValue = [1, 2]
          time = (time || '').replaceAll('/', '-')
        }   
        item.deliveryTimeObject = { ...newDeliveryTime, time: time !== undefined ? time : '' }
        const skuSpecifications = Array.isArray(item.skuSpecifications) ? item.skuSpecifications : JSON.parse(item.skuSpecifications)
        const _skuid = skuSpecifications.map((sp) => sp.valueKey).filter(Boolean).join("-");
        item.skuSpecifications = skuSpecifications;
        item._skuid = _skuid;
      });
      return skuList
    },
    updateRefundRule(categoryConfig) {
      this.categoryConfig = this.$set(this, 'categoryConfig', categoryConfig);
      const servicePromises = [
          {key: 'freshRotRefund', label: '坏了包退'}, 
          {key: 'brokenRefund', label: '破损包退'}, 
          {key: 'allergyRefund', label: '过敏包退'}, 
      ];
      this.servicePromiseSelectList = servicePromises.filter(promise => {
        const configVal = categoryConfig[promise.key];
        if(configVal === undefined) return false;
        promise.disabled = false;
        if(configVal === '0') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = false;
        } else if(configVal === '2') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = true;
        }
        return true;
      })
      const newRefundRule = categoryConfig.refundRuleList || [];
      this.refundRuleOptions = refundRuleList.filter(item => newRefundRule.includes(item.value))
      if (this.self_form.refundRule && newRefundRule.includes(this.self_form.refundRule)) {
        return ;
      }
      this.self_form.refundRule = newRefundRule.length ? newRefundRule[0] : ''
    },

    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        if (this.$refs.specificationRef) {
          const specificationValid = await this.$refs.specificationRef.validateSpecValueForm();
          if (!specificationValid) {
            this.$message.error('请检查商品规格信息是否正确维护');
            resolve(false);
            return;
          }
        }
        this.validPage().then(valid => {
          if (!valid) {
            this.$message.error('请完善表单');
            resolve(false);
            return false;
          }

          const c_names = this.$refs.cinput.method_getCategoryNames();
          let _formdata = JSON.parse(JSON.stringify(this.self_form));

          // 处理 deliveryTimeObject
          if (_formdata.deliveryTimeObject?.option === '1,2') {
            const { optionEnum } = _formdata.deliveryTimeObject;
            _formdata.deliveryTimeObject = {
              ..._formdata.deliveryTimeObject,
              option: optionEnum === 1 ? 1 : 2,
            };
          }
            _formdata.deliveryTimeObject.preSaleTime = Array.isArray(_formdata.deliveryTimeObject.preSaleTime)? _formdata.deliveryTimeObject.preSaleTime.join(',') : _formdata.deliveryTimeObject.preSaleTime
          if(_formdata.deliveryTimeObject?.option !== 4){
            delete _formdata.deliveryTimeObject.optionEnum;
          }
          delete _formdata.deliveryTimeObject.optionEnum;
          const [specifications, skuList] = this.getSpecificationData();
          skuList.forEach(sku => {
            // 现货+预售模式单独处理
            if (this.self_form.deliveryTimeObject.option !== 4) { 
              // 其他模式保持原有逻辑
              let { selectValue = '', time=null, type=null, option } = sku.deliveryTimeObject || {}
              let strSelectVal = selectValue? selectValue.join(','):''
              if(strSelectVal === '0,0') {
                option = 0;
                time = '0';
                type = 'TODAY';
              } else if(strSelectVal === '0,1') {
                option = 0;
                time = '1';
                type = 'RELATIVE_TIME_NEW';
              } else if(strSelectVal === '0,2') {
                option = 0;
                time = '2';
                type = 'RELATIVE_TIME_NEW';
              } else if(strSelectVal === '1,1') {
                option = 1;
                type = 'RELATIVE_TIME_NEW';
              } else if(strSelectVal === '1,2') {
                option = 2;
                type = 'ABSOLUTE_TIME_NEW';
                time = time.replaceAll('-', '/')
              } 
              sku.deliveryTimeObject = {
                time, 
                option,
                type
              }
            }
          })
          _formdata.specifications = specifications;
          _formdata.skuList = skuList;
          _formdata.categoryName = c_names[c_names.length - 1];
          _formdata.parentCategoryName = c_names[c_names.length - 2];
          _formdata.shopId = this.shopId;
          _formdata.categoryLeafId = last(_formdata.categoryIds)
          _formdata.faqList = this.faqList;
          _formdata.logisticsPlanId = this.logisticsPlanId || '';
          const lastLevelCateGory = this.$refs.cinput.method_getLastLevelCateGory()
          if(!_formdata.xhsCategoryId){
            _formdata.xhsCategoryId = lastLevelCateGory.xhsCid || ''
          }
          if(_formdata.deliveryTimeObject.option === 2 && _formdata.deliveryTimeObject.time) {
            _formdata.deliveryTimeObject.time = _formdata.deliveryTimeObject.time.replaceAll('-', '/')
          }
          // 恢复未显示店铺的物流方案和运费模版数据
          _formdata.xhsShopLogisticsPlanList = this.mergeHiddenShopData(cloneDeep(_formdata.xhsShopLogisticsPlanList), this.originalXhsShopLogisticsPlanList, this.shopList);
          _formdata.xhsShopShippingTemplateList = this.mergeHiddenShopData(cloneDeep(_formdata.xhsShopShippingTemplateList), this.originalXhsShopShippingTemplateList, this.shopList);
          _formdata.xhsShopBrandList = this.mergeHiddenShopData(cloneDeep(_formdata.xhsShopBrandList), this.originalXhsShopBrandList, this.shopList);
          // 提交表单
          console.log(cloneDeep(_formdata), '-----_formdata-----')
          // resolve(false);
          // return
          resolve(_formdata);
        });
      });
    },
    // 上传视频
    async handleVideo(value, type) {
      // type 0 删除 1 成功
      this.self_form.videoVo = type === 1 ? { ...value } : null;
      this.self_form.videoId = null;
      this.self_form.videoUrl = ''
      if(this.self_form.videoVo) {
        const videoId = await editCarouselVideo({
          carouselVideoVo: this.self_form.videoVo,
          baseItemId: this.self_form.baseItemId
        });
        this.self_form.videoUrl = value.originUrl
        this.self_form.videoId = videoId
      }
    },
    isParseTrue(time) {
      return time === '' || String(time).includes('-') || String(time).includes('/')
    },
    skuDeliveryTimeChange(value, deliveryTimeObject) {
      if(value[0] === 1 && value[1] === 1){
        deliveryTimeObject.time =  this.relativePre.min
      }else{
        deliveryTimeObject.time = ''
      }
    },
    deliveryTimeObjectChange(value) {
      // 基础配置
      const baseConfig = {
        option: value,
        optionEnum: '',
        time: '',
        preSaleTime: ''
      };

      // 根据不同选项设置特定配置
      const optionConfigs = {
        0: { // 现货模式
          time: '2'
        },
        [this.optionEnum.presale]: { // 全款预售模式
          optionEnum: 1
        },
        4: { // 现货+预售模式
          time: '2',
          preSaleTime: []
        },
        3: { // 按规格设置发货时间
          type: null
        }
      };

      // 更新发货时间对象
      this.self_form.deliveryTimeObject = {
        ...this.self_form.deliveryTimeObject,
        ...baseConfig,
        ...(optionConfigs[value] || {})
      };

      // 触发相关更新
      this.deliveryTimeChange(this.self_form.deliveryTimeObject.time);
      this.isShowSkuDeliveryTime();
    },
    // 添加监听发货时间变化的方法
    watchDeliveryTimeChange() {
      if (this.self_form.deliveryTimeObject?.option === 4) {
        this.self_form.skuList = this.self_form.skuList.map(sku => {
          if (sku.deliveryFlag === 1) { // 现货
            sku.deliveryTimeObject = {
              option: 0,
              time: this.self_form.deliveryTimeObject.time,
              type: 'RELATIVE_TIME_NEW'
            };
          } else if (sku.deliveryFlag === 2) { // 预售
            sku.deliveryTimeObject = {
              option: 1,
              time: this.self_form.deliveryTimeObject.preSaleTime,
              type: 'RELATIVE_TIME_NEW'
            };
          }
          return sku;
        });
      }
    },
    deliveryTimeObjectChangeEnum(value) {
      this.self_form.deliveryTimeObject = {
        ...this.self_form.deliveryTimeObject,
        optionEnum: value,
        time: '',
      }
      this.deliveryTimeChange(this.self_form.deliveryTimeObject.time)
    },
    isShowSkuDeliveryTime() {
      this.skuTableCols.forEach(col => {
        if(col.prop == 'deliveryTime') {
          col.unvisible = this.self_form.deliveryTimeObject.option !== 3
        }
      })
    },
    // 修改发货时间类型处理 
    deliveryTimeChange(v) {
      const option = this.self_form.deliveryTimeObject.option
      const optionEnum = this.self_form.deliveryTimeObject.optionEnum
      let type = null
      if(option == 0) {
        type = v === '0' ? 'TODAY' : 'RELATIVE_TIME_NEW'
      } else if (optionEnum == 1) {
        type = 'RELATIVE_TIME_NEW'
      } else if (optionEnum == 2) {
        type = 'ABSOLUTE_TIME_NEW'
      } else if(option === 4){
        type = 'RELATIVE_TIME_NEW'
      }
      this.self_form.deliveryTimeObject.type = type || null
    },
    // 获取物流方案
    async getLogisticsList() {
      if(this.logisticsPlanId) return
      const res = await logisticsList();
      const logisticsPlans = res.data?.logisticsPlans || [];
      if (logisticsPlans.length) {
        this.logisticsPlanId = logisticsPlans[0].planInfoId || '';
      }
    },
    // 获取发货方式规则
    async getDeliveryRules() {
      const lastLevelCateGory = this.$refs.cinput.method_getLastLevelCateGory()
      if(!this.shopId || !this.logisticsPlanId) return
      const res = await getXhsDeliveryRule({
        shopId: this.shopId,
        categoryId: this.self_form.xhsCategoryId || lastLevelCateGory.xhsCid || this.categoryId,
        logisticsPlanId: this.logisticsPlanId
      });
      let stepPresaleObj = res.stepPresale && res.stepPresale.length ? res.stepPresale[0].stepDeliveryTime: []
      stepPresaleObj = stepPresaleObj.map(item=>String(item/24))
      this.stepDeliveryTime = stepPresaleObj
      const skuExistingChildren = []
      const existing = res.existing || [];
      const presale = res.presale || [];
      const existingList = existing.map(item => {
        let type = '';
        let label = '';
        let time = '';
        if(item.timeType === 3) {
          label = '当日发货';
          type = 'TODAY';
          time = '0'
        } else {
          label = item.value + '小时';
          type = 'RELATIVE_TIME_NEW';
          time = String(item.value / 24)
        }
        skuExistingChildren.push({
          value: time,
          label,
          type
        })

        return {
          type,
          label,
          time,
          ...item
        }
      })
      const relativePre = presale.find(item => item.timeType === 4)  // 时段预售（相对时间）
      const absolutePre = presale.find(item => item.timeType === 5)  // 定时预售（绝对时间）
      this.existingList = existingList;
      this.relativePre = { ...relativePre, min: relativePre.min / 24, max: relativePre.max / 24};
      this.absolutePre = absolutePre;

      this.skuDeliveryOptions = [
        {
          value: 0,
          label: '现货模式',
          children: skuExistingChildren
        },
        {
          value: 1,
          label: '预售',
          children: [
            {
              value: 1,
              label: '时段预售',
              type: 'RELATIVE_TIME_NEW'
            },
            {
              value: 2,
              label: '定时预售',
              type: 'ABSOLUTE_TIME_NEW'
            }
          ]
        },
      ]
      
    },
    //添加问题
    addQuestion(){
      this.faqList.push({
        question:'',
        answer:''
      })
    },
    // 删除问题
    deleteQuestion(index){
      this.faqList.splice(index, 1);
    },
    //获取规格映射
    async getMapSku() {
      if (!this.categoryId) return;
      try {
        let specifications = cloneDeep(this.specifications?.length ? this.specifications : this.orginSpecifications);
        const res = await variations({
          leafCategoryId: this.categoryId,
          shopId: this.shopId,
        });
        this.variations = res.data.variations;
        this.xhsSpecMaxNum = res.data?.xhsSpecMaxNum || 2
        // 处理组合铺货模式的规格匹配
        if (this.isGroupPuhuo) {
          this.handleGroupPuhuoSpecifications(specifications);
          return;
        } else {
          if(this.variations?.length < specifications?.length) {
            specAutoMerge({
              catId: this.categoryId,
              baseItemId: this.baseItemId,
            }).then(res => {
              const skuList = cloneDeep(this.self_form.skuList || []);  
              const mergeSkuList = res?.skuList || [];
              skuList.forEach(item => {
                const findItem = mergeSkuList.find(mergeItem => mergeItem.baseSkuId === item.baseSkuId);
                if(findItem && findItem.skuSpecifications) {
                  item.skuSpecifications = JSON.parse(findItem.skuSpecifications);
                }
              })
              this.self_form.skuList = skuList;
              this.initSelfFormSkuList();
              this.handleNormalSpecifications(JSON.parse(res?.specifications || '[]'));
            })
          } else {
            // 处理普通模式的规格验证
            this.handleNormalSpecifications(specifications);
          }
        }
      } catch (error) {
        console.error('获取SKU映射失败:', error);
        this.$message.error('获取规格数据失败，请重试');
      }
    },
    
    // 处理团购铺货模式的规格匹配
    handleGroupPuhuoSpecifications(specifications) {
      if (!specifications?.length || !this.variations?.length) return;
      
      this.specifications = specifications.map(spec => {
        const specName = spec.name || '';
        const matchedVariation = this.findBestMatchVariation(specName);
        const targetVariation = matchedVariation || this.variations[0];
        
        return {
          ...spec,
          name: targetVariation.name,
          nameKey: targetVariation.id
        };
      });
    },
    
    // 查找最佳匹配的规格变体
    findBestMatchVariation(specName) {
      if (!specName) return null;
      
      // 优化的模糊匹配算法
      const specChars = specName.split('');
      let bestMatch = null;
      let bestScore = 0;
      
      for (const variation of this.variations) {
        if (!variation.name) continue;
        
        const variationChars = variation.name.split('');
        const score = this.calculateMatchScore(specChars, variationChars);
        
        // 匹配度阈值提高到 40% 以获得更准确的匹配
        if (score > 0.4 && score > bestScore) {
          bestMatch = variation;
          bestScore = score;
        }
      }
      
      return bestMatch;
    },
    
    // 计算匹配分数
    calculateMatchScore(specChars, variationChars) {
      if (specChars.length === 0) return 0;
      
      const matchCount = specChars.reduce((count, specChar) => {
        return variationChars.some(varChar => 
          specChar === varChar || 
          specChar.includes(varChar) || 
          varChar.includes(specChar)
        ) ? count + 1 : count;
      }, 0);
      
      return matchCount / specChars.length;
    },
    
    // 处理普通模式的规格验证
    handleNormalSpecifications(specifications) {
      specifications.forEach(spec => {
        let findIndex = this.variations.findIndex(item => item.name === spec.name)
        if(findIndex === -1) {
          findIndex = this.variations.findIndex(item =>  item.name.includes(spec.name) || spec.name.includes(item.name))
        }
        if(findIndex > -1) {
          spec.nameKey = this.variations[findIndex].id
          spec.name = this.variations[findIndex].name
        }
      })
      this.specifications = specifications.splice(0, this.xhsSpecMaxNum);
    },

    clickTemPlateFill(row) {
      const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : []
      this.self_form.attributeList = platformCatProp
    },
    useGroupImages(data, type) {
      const {mainImages=[], detailImages=[], speImages=[]} = data
      let pic = [], description = [];
      if(type === 'add') {
        pic = [...this.self_form.imageList].filter(Boolean)
        description = [...this.self_form.imageDescriptionsList]
      }
      if(mainImages.length) {
        this.self_form.imageList = [...pic, ...mainImages].filter(Boolean).slice(0, 10)
      }
      if(detailImages.length) {
        this.self_form.imageDescriptionsList = [...description, ...detailImages].filter(Boolean)
      }
      const firstSpec = this.specifications[0];
      if (firstSpec && firstSpec.values && speImages.length) {
        firstSpec.values.forEach(specValue => {
          // 如果是新增模式且已有图片，则跳过
          if (type === 'add' && specValue.imageUrl) {
            return;
          }
          
          // 查找匹配的图片
          const matchedImage = speImages.find(img => img.name === specValue.value);
          if (matchedImage) {
            specValue.imageUrl = matchedImage.imgUrl;
          }
        });
      }
    },
    getGroupImagesList (list){
      this.showGroupImages = !!list?.length
    },
    editGroupImages(){
      this.changeToBase('openGroupImgs')
    },

    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({ shopType: "xhs" });
      // 上架设置
      this.self_form.shelfState = this.form.shelfState ? this.form.shelfState : (res?.shelfState || 2);
      this.autoCropImageConfigList = res.autoCropImageConfigList || [];
    },

  },
};
</script>

<style lang="scss" scope>
a{
  color:#6189f5;
  text-decoration: none;
}
.no-specifications{
  display: flex;
  justify-content: center;
  align-items: center;
  margin:20px;
  color:#ccc;
}
.delivery-mixed-mode {
  .delivery-section {
    margin-bottom: 15px;
    .section-title {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>